import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-top-banner2',
  templateUrl: './top-banner2.component.html',
  styleUrls: ['./top-banner2.component.scss']
})
export class TopBanner2Component implements OnInit {

  @Input() topbanner2Type:string;

  constructor() { }

  ngOnInit(): void {
  }

}
